import * as React from "react"

export interface DownloadURL {
  fileName?: string
  url: string
}

export function useDownloadUrls() {
  return React.useCallback((downloadUrls: DownloadURL[]) => {
    downloadUrls.forEach((downloadUrl) => {
      const link = document.createElement("a")
      link.href = downloadUrl.url
      if (downloadUrl.fileName) {
        link.download = downloadUrl.fileName
      }
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }, [])
}
